/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/score.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Scores an expression. Only full text functions will be scored. Returns scores for all the resulting docs.
 *
 * @example
 * FROM books METADATA _score
 * | WHERE match(title, "Return") AND match(author, "Tolkien")
 * | EVAL first_score = score(match(title, "Return"))
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'score',
  signatures: [
    {
      params: [
        {
          name: 'query',
          type: 'boolean',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
